import React from "react";
import { Sparkles, Flame, Cloud } from "lucide-react";

/** Visual badge showing affinity level based on overall compatibility. */
export const tierFromScore = (overall) => {
  if (overall >= 80) return "high";
  if (overall >= 50) return "medium";
  return "low";
};

const TIERS = {
  high: {
    label: "Grande afinidade",
    short: "Alta",
    icon: Sparkles,
    classes: "bg-[#C5A880]/15 border-[#C5A880] text-[#C5A880]",
  },
  medium: {
    label: "Média afinidade",
    short: "Média",
    icon: Flame,
    classes: "bg-amber-400/10 border-amber-400/40 text-amber-300",
  },
  low: {
    label: "Baixa afinidade",
    short: "Baixa",
    icon: Cloud,
    classes: "bg-white/5 border-white/15 text-[#A29F9B]",
  },
};

const AffinityBadge = ({ score, tier, size = "md", short = false }) => {
  const t = tier || tierFromScore(score || 0);
  const meta = TIERS[t] || TIERS.low;
  const Icon = meta.icon;
  const sz = {
    sm: "px-2 py-0.5 text-[10px]",
    md: "px-2.5 py-1 text-xs",
    lg: "px-3 py-1.5 text-sm",
  }[size] || "px-2.5 py-1 text-xs";
  const iconSz = { sm: "w-3 h-3", md: "w-3.5 h-3.5", lg: "w-4 h-4" }[size] || "w-3.5 h-3.5";
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border uppercase tracking-wider ${sz} ${meta.classes}`}
      data-testid={`affinity-${t}`} title={meta.label}>
      <Icon className={iconSz} />
      {short ? meta.short : meta.label}
    </span>
  );
};

export default AffinityBadge;
